module.exports = __webpack_public_path__ + "img/2.8d0b6979.webp";